import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { InformationVideosEffects } from '@appStore/learning/effects/information-videos.effects';

export const effects: any[] = [ 
    InformationVideosEffects 
];

@NgModule({
  imports: [EffectsModule.forFeature(effects)]
})
export class LearningEffectsModule {}
